import { historyStorage } from '@/utils/historyStorage'

const EXCLUDED_ROUTES = ['/orders/new', '/dispatcher/staff']
const MAX_HISTORY_LENGTH = 10

export function addToHistory(path) {
    if (path === '/' || EXCLUDED_ROUTES.includes(path)) return

    const history = historyStorage.get()
    if (history[history.length - 1] === path) return

    historyStorage.set([...history, path].slice(-MAX_HISTORY_LENGTH))
}

export function goBackOrFallback(router, fallback = { name: 'order-list' }) {
    if (!router) return

    const history = historyStorage
        .get()
        .filter(p => !EXCLUDED_ROUTES.includes(p))

    // Нужно минимум 2 записи: [предыдущая, текущая]
    if (history.length >= 2) {
        const prev = history[history.length - 2]
        historyStorage.set(history.slice(0, -1))

        router.push(prev).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.error(err)
        })
    } else {
        historyStorage.clear()
        router.push(fallback).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.error(err)
        })
    }
}
